<template>
  <div class="data-balance-rechange">
    <div class="page-title">
      {{ $t('merchant.account_balance') }}
    </div>
    <div class="rechange-middle">
      <div class="custom-breadcrumbs">
        <i class="el-icon-arrow-left icon-back" @click="onClickFistBread('Financial_Manage_Balance')" />
        <span class="first-span" @click="onClickFistBread('Financial_Manage_Balance')">{{ $t('data.recharge_record') }}</span>
        <span style="margin: 0 12px"> /</span>

        <span>  {{ $t('data.step') }} 3</span>
      </div>
      <div class="select-bank">
        <el-form ref="rechargeForm" label-position="left" :model="rechargeForm" status-icon label-width="150px">
          <el-form-item
            :label="$t('data.payment_type')+':'"
            prop="top_up_type"
            :rules="[
              { required: true, message: 'Payment Type cannot be empty', trigger: ['blur', 'change']}
            ]"
          >
            <el-radio-group v-model="rechargeForm.top_up_type">
              <el-radio :label="4">{{ $t('data.thai_qr_payment') }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item :label="$t('data.payment_account')+':'">
            <div> {{ rechargeInfo.issuing_bank_account_num || '' }} </div>

          </el-form-item>
          <el-form-item :label="$t('components.amount')+':'">
            <div> {{ rechargeInfo.amount || '' }} THB </div>
          </el-form-item>
        </el-form>
      </div>
      <el-divider class="divider" />
      <div style="display: flex;flex-direction: column;align-items: center;">
        <span class="scan_qr_code_text">{{ $t('data.scan_qr_code') }}</span>
        <span class="scan_qr_code_tip_text">{{ $t('tips.scan_qr_code_tip') }}</span>
        <span class="scan_qr_code_tip_text">{{ $t('tips.qr_code_expires_in') }}: <span style="color: #1D3A71;font-weight: 600;font-size: 16px;margin-left: 4px"> {{ countdown }}</span></span>
        <div v-loading="loading" :class="['qr-code-container', { expired: isInvalid }]">
          <div ref="qrCodeUrl" />
          <div class="qr-code-overlay">
            <div class="qr-code-text">
              <img :src="require(`@/assets/thai_qr_img/expired.png`)" style="width: 48px;height: 48px">
              {{ $t('tips.qr_code_expires') }}
            </div>
          </div>
        </div>
        <div style="display: flex;padding: 12px;background: #1D3A7105;border: 1px solid #D3D7DF;border-radius: 12px;margin-top: 12px">
          <el-image
            v-for="(channel,index) in srcList"
            :key="index"
            style="width: 46px; height: 46px; margin-right: 12px"
            :src="require(`@/assets/thai_qr_img/${channel}.png`)"
          />
        </div>
        <el-button style="margin-top: 12px" :disabled="!isInvalid" type="primary" @click="goToOpenApiBluepayThaiDynamicQr()">{{ $t('data.refresh') }}</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import { goToOpenApiBluepayThaiDynamicQr } from '@/api/settlement/settlement'
import QRCode from 'qrcodejs2'
import { GetRechargeInfo } from '@/api/merchant-manage/merchant-manage'

export default {
  name: 'Balance_Rechange',
  components: {
  },
  props: {
    balance: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      balanceInfo: { qrcodeContent: '' },
      rechargeForm: { top_up_type: 4, amount: 0 },
      rechargeInfo: {},
      base64Image: '',
      qrcodeObj: '',
      countdown: null,
      qrString: '',
      remainingSeconds: null,
      isInvalid: false,
      srcList: ['thai_qr_img_1', 'thai_qr_img_2', 'thai_qr_img_3', 'thai_qr_img_4', 'thai_qr_img_5', 'thai_qr_img_6', 'thai_qr_img_7'],
      time: '',
      loading: false
    }
  },
  computed: {
  },
  created() {
    if (!this.$route.query.id || this.$store.getters.curCountry.country_code !== 'TH') {
      this.onClickFistBread('Financial_Manage_Balance')
    } else {
      this.initData()
      document.addEventListener('visibilitychange', this.initData)
    }
  },
  beforeDestroy() {
    if (this.interTimer) {
      clearInterval(this.interTimer)
    }
    if (this.interval) {
      clearInterval(this.interval)
    }
  },
  destroyed() {
    document.removeEventListener('visibilitychange', this.initData)
  },
  methods: {
    initData() {
      this.id = this.$route.query.id
      this.getRechargeInfoSetInterval()
      this.getRechargeInfo()
    },
    goToOpenApiBluepayThaiDynamicQr() {
      const params = { id: this.id }
      this.loading = true
      goToOpenApiBluepayThaiDynamicQr(params).then(res => {
        if (res.code === 10000) {
          this.bluepay_qr_generate_resp = res.data.bluepay_qr_generate_resp
          this.balanceInfo = res.data
          this.qrString = this.bluepay_qr_generate_resp.qr_code_content
          this.startCountdown()
          this.generateBase64QRCode()
          this.startSetInterval()
        }
      }).catch(e => {
        this.onClickFistBread('Financial_Manage_Balance')
        this.invalidateQRCode()
      }).finally(() => {
        this.loading = false
      })
    },
    generateBase64QRCode() {
      this.$nextTick(() => {
        if (this.qrcodeObj) {
          this.$refs.qrCodeUrl.innerHTML = ''
        }
        this.qrcodeObj = new QRCode(this.$refs.qrCodeUrl, {
          text: this.qrString, // 需要转换为二维码的内容
          width: 200,
          height: 200,
          colorDark: '#000000',
          colorLight: '#ffffff',
          correctLevel: QRCode.CorrectLevel.H
        })
      })
      this.isInvalid = false
    },
    onClickFistBread(name) {
      this.$router.push({ name })
    },
    startCountdown() {
      if (!this.balanceInfo.expires_time_stamp) {
        return
      }
      const backendTimestamp = Math.floor(this.balanceInfo.expires_time_stamp / 1000)
      const currentTime = Math.floor(this.balanceInfo.current_time_stamp / 1000)
      this.remainingSeconds = backendTimestamp - currentTime
      if (this.interval) {
        clearInterval(this.interval)
      }
      this.interval = setInterval(() => {
        if (this.remainingSeconds > 0) {
          this.remainingSeconds--
          this.updateCountdown()
        } else {
          this.invalidateQRCode()
          clearInterval(this.interval)
          clearInterval(this.interTimer)
        }
      }, 1000)

      this.updateCountdown()
    },
    updateCountdown() {
      const minutes = Math.floor((this.remainingSeconds % 3600) / 60)
      const seconds = this.remainingSeconds % 60
      this.countdown = `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`
    },
    getRechargeInfo() {
      if (this.id) {
        GetRechargeInfo({ id: this.id }).then(res => {
          this.rechargeInfo = res.data
          this.rechargeInfo.amount = this.rechargeInfo.amount / 100
        })
      }
    },
    getRechargeInfoSetInterval() {
      if (this.id) {
        GetRechargeInfo({ id: this.id }).then(res => {
          if (res.data.settle_status === 2) {
            clearInterval(this.interval)
            clearInterval(this.interTimer)
            this.$alert(this.$t('tips.chillpay_tips'), this.$t('components.tips'), {
              confirmButtonText: this.$t('components.confirm'),
              type: 'warning'
            }).then(() => {
              this.$router.push({ name: 'Financial_Manage_Balance', params: { activeName: 'Recharge_Record' }})
            }).catch(() => {
              this.$router.push({ name: 'Financial_Manage_Balance', params: { activeName: 'Recharge_Record' }})
            })
          } else {
            this.goToOpenApiBluepayThaiDynamicQr()
          }
        })
      }
    },
    startSetInterval() {
      if (this.interTimer) {
        clearInterval(this.interTimer)
      }
      this.interTimer = setInterval(() => {
        this.getRechargeInfoSetInterval()
        this.startSetInterval()
      }, 5000)
    },
    invalidateQRCode() {
      this.isInvalid = true // 设置二维码失效状态
    }
  }
}
</script>
<style>
.data-balance-rechange .bank-label{
    width: 210px;
    font-size: 14px;
    color: #1D3A71;
    font-weight: 500;  font-family: 'Inter-Medium';
}
</style>
<style lang="scss" scoped>
.upload-box {
  ::v-deep .el-upload-dragger {
    width: 515px;
  }
}
.divider {
  background: #D3D7DF;
}
.bank-info{
  font-weight: 400;
  font-size: 16px;
  line-height: 1.2;
  color: #434343;
}
.data-balance-rechange{
  margin: 40px 57px 50px 32px;
  .rechange-middle{
   border-top: 1px solid #D3D7DF;
  }
  .custom-breadcrumbs{
    display: flex;
    justify-items: center;
    margin: 32px 0 40px;
    color: #3855F1;
    cursor: pointer;
    .icon-back{
      margin-right: 12px;
      margin-top: 2px;
    }
    // .first-span{
    //   margin-right: 12px;
    // }
  }
  .select-bank-title{
    margin-bottom: 16px;
    font-weight: 500;  font-family: 'Inter-Medium';
    font-size: 16px;
    color: #1D3A71;
  }
  .select-bank{
    .bank{
      display: inline-block;
      margin-right: 24px;
      margin-bottom: 32px;
      padding: 10px 50px;
      border-radius: 2px;
      font-size: 14px;
      text-align: center;
      color: #1D3A71;
      background: #FFFFFF;
      border: 1px solid #1D3A71;
      cursor: pointer;
      &.active{
        color: #FFFFFF;
        background: #1D3A71;
      }
    }
  }
  .input-item{
    width: 364px;
  }
  .tip-enter{
    margin-bottom: 24px;
    font-weight: 400;
    font-size: 14px;
    color: #7A869E;
  }
  .info{
    margin-top: 32px;
    margin-bottom: 16px;
    font-weight: 500;  font-family: 'Inter-Medium';
    font-size: 18px;
    color: #3855F1;
  }
  .tip{
    margin-bottom: 32px;
    font-weight: 400;
    font-size: 14px;
    color: #7A869E;
  }

 .dialog-footer{
    padding-top: 18px;
    .btn-footer{
      width: 132px;
      height: 40px;
      font-size: 12px;
      // color: #FFFFFF;
      // background: #3855F1;
      border-radius: 4px;
      &:hover{
        opacity: .9;
      }
    }
    .btn-defalt{
      margin-right: 10px;
      color: #616D85;
      background: #FFFFFF;
      border: 1px solid #98A1B4;
    }
  }
}
.content-file{
  display: inline-block;
  width: 330px;
  vertical-align: middle;
  color:#3855F1;
  text-decoration: underline;
  cursor: pointer;
  overflow:hidden;
  text-overflow:ellipsis;
  white-space:nowrap;
}
.scan_qr_code_text{
  margin-top: 12px;
  margin-bottom: 12px;
  font-size: 18px;
  font-weight: 400;
  color: #1D3A71;
}
.scan_qr_code_tip_text{
  font-size: 14px;
  font-weight: 400;
  color: #7A869E;
  margin-bottom: 12px;
}
.qr-code-container {
  position: relative;
  display: inline-block;
  width: 200px;
  height: 200px;
}
.qr-code-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 20px;
  text-align: center;
  opacity: 0;
  transition: opacity 0.3s;
}
.qr-code-container.expired .qr-code-overlay {
  opacity: 1;
}
.qr-code-text{
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>
